import { ActionSanitizer } from 'store/devToolsActionSantizer';
import { AnyAction } from 'store/store';
import {
    ShareUsersActionType,
    ShareUsersSetAction,
} from 'app/store/shareUsers/actions';

export const shareUsersSetActionSanitizer: ActionSanitizer = <
    A extends AnyAction,
>(
    action: A
) => {
    if (action.type !== ShareUsersActionType.SET_SHARE_USERS) {
        return action;
    }

    const shareUsersSetAction = action as unknown as ShareUsersSetAction;

    return {
        type: ShareUsersActionType.SET_SHARE_USERS + '_SANITIZED',
        payload: {
            count: shareUsersSetAction.payload?.length,
        },
    } as unknown as A;
};
